import axios from 'axios';

export async function getContractGroups({ userId, request }) {
    const { data } = await axios.get(`/vonq/${userId}/groups/contract`, request);
    return data;
}


export async function editContractGroup({ userId, request, groupId }) {
    const { data } = await axios.put(`/vonq/${userId}/groups/contract/${groupId}`, request);
    return data;
}


export async function moveContractGroups({ userId, request }) {
    const { data } = await axios.post(`/vonq/${userId}/groups/contract/move`, request);
    return data;
}



export async function deleteContractGroup({ userId, groupId }) {
    const { data } = await axios.delete(`/vonq/${userId}/groups/contract/${groupId}`);
    return data;
}
